import React from 'react';
import { LegalPage } from './LegalPages';
import { contactInfo } from '../mock';
import { useLang } from '../context/LanguageContext';

export default function TermsConditions() {
  const { lang } = useLang();
  return (
    <LegalPage title={lang === 'en' ? 'Terms & Conditions' : 'नियम और शर्तें'} subtitle={lang === 'en' ? 'Please read carefully before using our services' : 'सेवा उपयोग से पहले ध्यान से पढ़ें'}>
      <p>
        These Terms &amp; Conditions govern your use of the website
        <b> {contactInfo.domain} </b> operated by Navavidha Bhakti. By accessing or using our
        services, you agree to be bound by these terms. If you do not agree, please do not
        use our services.
      </p>

      <h2>1. Nature of Service</h2>
      <p>
        Navavidha Bhakti facilitates online booking of Hindu devotional pujas performed by
        certified Vedic Pandit Jis at various tirth kshetras across Bharat. We act as a
        service facilitator between devotees and Pandit Jis. Our services are advisory and
        devotional in nature; we do not guarantee specific spiritual or material outcomes.
      </p>

      <h2>2. Eligibility</h2>
      <p>
        You must be at least 18 years old and legally capable of entering a contract under
        Indian law to book services on our platform.
      </p>

      <h2>3. Booking & Sankalp</h2>
      <ul>
        <li>Every booking requires accurate <b>Name, Gotra, Phone, Email and Shipping Address</b>.</li>
        <li>Sankalp will be performed strictly with the details you provide. We are not
          responsible for wrong details entered by you.</li>
        <li>Puja date and time are announced in advance. In case of any change due to Panchang
          / temple availability, we will notify you.</li>
        <li>If you don’t know your gotra, you may use <b>Kashyap</b> gotra as per scriptural
          convention.</li>
      </ul>

      <h2>4. Payment</h2>
      <ul>
        <li>All payments must be made in Indian Rupees (INR) unless stated otherwise.</li>
        <li>Payments are processed via <b>Razorpay</b> (UPI, cards, netbanking, wallets) or
          manual UPI as per our checkout.</li>
        <li>Booking is confirmed only after payment is successfully received.</li>
        <li>Prices displayed include all applicable taxes unless expressly stated otherwise.</li>
      </ul>

      <h2>5. User Responsibilities</h2>
      <ul>
        <li>Provide truthful, accurate and complete information at the time of booking.</li>
        <li>Follow Brahmacharya, cleanliness and meditate on the Ishtadev on the puja day.</li>
        <li>Not to use our services for any unlawful, fraudulent, or offensive activity.</li>
        <li>Not to attempt unauthorized access to our systems, admin panel or Pandit accounts.</li>
      </ul>

      <h2>6. Intellectual Property</h2>
      <p>
        All content on this site — including logo, branding, images, videos, mantras
        catalogues, and puja descriptions — is the intellectual property of Navavidha Bhakti
        unless otherwise noted. You may not reproduce, distribute or exploit them for
        commercial purposes without written consent.
      </p>

      <h2>7. Puja Video & Recordings</h2>
      <p>
        Recordings of pujas are shared with the specific devotee (or their family) who booked
        the Sankalp. You must not upload the video publicly, edit it misleadingly, or use it
        for commercial gain.
      </p>

      <h2>8. Limitation of Liability</h2>
      <p>
        Navavidha Bhakti shall not be liable for any indirect, incidental or consequential
        damages arising out of use of the website or services. Our maximum liability shall be
        limited to the amount you paid for the specific puja booking in question.
      </p>

      <h2>9. Force Majeure</h2>
      <p>
        We are not responsible for delays or failures caused by events beyond our reasonable
        control such as natural calamities, temple closures, government restrictions,
        strikes, internet outages or courier failures.
      </p>

      <h2>10. Governing Law & Jurisdiction</h2>
      <p>
        These terms are governed by the laws of India. Any dispute arising out of or in
        connection with these terms shall be subject to the exclusive jurisdiction of the
        courts of <b>Deoghar, Jharkhand</b>.
      </p>

      <h2>11. Modification</h2>
      <p>
        We may revise these terms at any time by updating this page. Your continued use of
        the website after such changes shall be deemed acceptance of the updated terms.
      </p>

      <h2>12. Contact</h2>
      <p>
        For any queries about these terms, contact us at
        <a href={`mailto:${contactInfo.email}`}> {contactInfo.email}</a>.
      </p>
    </LegalPage>
  );
}
